/** Human labels for the codes the database returns. Sentence case, full words. */

export const SELF_SOURCE: Record<string, string> = {
  not_answered: 'Not answered',
  tiktok: 'TikTok',
  google: 'Google',
  friend: 'A friend',
  linkedin: 'LinkedIn',
  instagram: 'Instagram',
  youtube: 'YouTube',
  twitter: 'X (Twitter)',
  podcast: 'Podcast',
  university_careers: 'University careers service',
  university_society: 'University society',
  ai_assistant: 'AI assistant (typed under Other)',
  other: 'Other',
};

export const CHANNEL: Record<string, { label: string; note?: string }> = {
  not_captured: { label: 'Not captured', note: 'Lost at the sign-in redirect or before cookie consent' },
  own_site: { label: 'Our marketing site', note: 'Came from intervyo.co.uk; the first source before it was lost' },
  direct: { label: 'Direct', note: 'No referrer and no campaign tags' },
  search: { label: 'Search' },
  ai_assistant: { label: 'AI assistant', note: 'ChatGPT, Perplexity, Claude and similar' },
  social: { label: 'Social' },
  tiktok_paid: { label: 'TikTok ads' },
  tiktok_organic: { label: 'TikTok' },
  google_ads: { label: 'Google Ads' },
  referral: { label: 'Referral link' },
  campaign: { label: 'Tagged campaign' },
  other_site: { label: 'Another website' },
  other: { label: 'Other' },
};

export const selfLabel = (k: string | null | undefined) => SELF_SOURCE[k ?? 'not_answered'] ?? (k ? k.replace(/_/g, ' ') : 'Not answered');
export const channelLabel = (k: string | null | undefined) => CHANNEL[k ?? 'not_captured']?.label ?? (k ? k.replace(/_/g, ' ') : 'Not captured');

/** sessions.type */
export const SESSION_TYPE: Record<string, string> = {
  practice: 'Video interview practice',
  live: 'Live interview',
  cv: 'CV analysis',
  ac: 'Assessment centre',
  superday: 'Superday',
  assessment: 'Psychometric result',
};
export const sessionTypeLabel = (t: string | null | undefined) => SESSION_TYPE[t ?? ''] ?? (t ?? 'Unknown');

export const CAREER_STAGE: Record<string, string> = {
  spring_week: 'Spring week',
  summer_intern: 'Summer internship',
  summer_internship: 'Summer internship',
  graduate: 'Graduate',
  off_cycle: 'Off-cycle internship',
  not_given: 'Not given',
};
export const stageLabel = (s: string | null | undefined) => CAREER_STAGE[s ?? 'not_given'] ?? (s ? s.replace(/_/g, ' ') : 'Not given');

export const PLAN: Record<string, string> = { base: 'Monthly', pro: 'Monthly (legacy pro)', pass: 'Season Pass', free: 'Free', pack: 'Pack', premium: 'Premium' };
export const planLabel = (p: string | null | undefined) => PLAN[p ?? 'free'] ?? (p ?? 'Free');

export const sentence = (s: string | null | undefined) => {
  if (!s) return '';
  const t = s.replace(/_/g, ' ');
  return t.charAt(0).toUpperCase() + t.slice(1);
};
